module.exports = __webpack_public_path__ + "img/sec3_slide4_mobile.f86c84e4.jpg";